var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "meta-56",
  "use": "meta-56-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" id=\"meta-56\"><g stroke=\"#4E4E4E\" stroke-width=\"1.3\" fill=\"none\" fill-rule=\"evenodd\"><path d=\"M7.53 23.574a.927.927 0 0 0-.88.926c0 .47.38.85.85.85H24A1.35 1.35 0 0 0 25.35 24l-.002-.063a1.252 1.252 0 0 0-1.313-1.188l-16.504.825zm10.776-.097L24.17 7.49\" /><rect transform=\"rotate(-40 22.262 8.077)\" x=\"19.912\" y=\"7.227\" width=\"4.7\" height=\"1.7\" rx=\".85\" /><path d=\"M21.824 13.891h-10.55m8.784 5.687l2.634 3.016\" stroke-linecap=\"round\" /></g></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol